{
  "app": {
    "name": "Compendio",
    "tagline": "Una carpeta de Markdown que es la base de datos de referencia",
    "loading": "Cargando…",
    "retry": "Reintentar",
    "cancel": "Cancelar",
    "save": "Guardar",
    "saving": "Guardando…",
    "delete": "Eliminar",
    "edit": "Editar",
    "close": "Cerrar",
    "back": "Atrás",
    "next": "Siguiente",
    "finish": "Finalizar",
    "confirm": "Confirmar",
    "search": "Buscar",
    "skipToContent": "Ir al contenido",
    "menu": "Menú",
    "theme": {
      "label": "Tema",
      "light": "Claro",
      "dark": "Oscuro",
      "auto": "Seguir al sistema"
    },
    "language": {
      "label": "Idioma"
    },
    "error": {
      "title": "Algo salió mal",
      "generic": "No se pudo completar la petición.",
      "offline": "Parece que no tienes conexión.",
      "notFound": "Esa página no existe, o no tienes acceso a ella."
    }
  },
  "auth": {
    "signIn": "Iniciar sesión",
    "signOut": "Cerrar sesión",
    "userName": "Usuario",
    "password": "Contraseña",
    "rememberMe": "Mantener la sesión iniciada",
    "failed": "El usuario y la contraseña no coinciden.",
    "profile": "Perfil",
    "displayName": "Nombre visible",
    "email": "Correo electrónico",
    "changePassword": "Cambiar la contraseña",
    "currentPassword": "Contraseña actual",
    "newPassword": "Contraseña nueva",
    "passwordChanged": "Se ha cambiado tu contraseña.",
    "profileSaved": "Se ha guardado tu perfil."
  },
  "setup": {
    "title": "Configurar Compendio",
    "subtitle": "Cuatro pasos breves. Nada de esto necesita un servidor de base de datos ni conexión a internet.",
    "steps": {
      "language": "Idioma",
      "account": "Administrador",
      "content": "Carpeta de contenido",
      "access": "Acceso por defecto",
      "https": "HTTPS"
    },
    "language": {
      "heading": "¿Qué idioma debe usar esta instancia?",
      "help": "Después cada persona puede elegir el suyo. Este es el que se usa para quien no lo haya hecho."
    },
    "account": {
      "heading": "Crea la cuenta de administrador",
      "help": "Compendio no envía correo, así que guarda estas credenciales en un sitio seguro. La recuperación es un comando en el servidor.",
      "passwordHint": "Al menos 12 caracteres.",
      "instanceName": "¿Cómo se debe llamar este wiki?"
    },
    "content": {
      "heading": "Dónde viven tus páginas",
      "help": "Cada página es un archivo Markdown en esta carpeta. Ábrela en VS Code, haz copias, sincronízala: es tuya.",
      "path": "Carpeta de contenido"
    },
    "access": {
      "heading": "¿Quién puede leer una carpeta nueva por defecto?",
      "everyone": "Cualquiera que inicie sesión puede leer",
      "everyoneHelp": "La opción habitual. Después puedes restringir carpetas concretas.",
      "nobody": "Nadie hasta que tú lo indiques",
      "nobodyHelp": "Para una instancia donde casi todo el contenido es sensible."
    },
    "https": {
      "heading": "HTTPS (opcional)",
      "help": "Compendio puede emitir su propio certificado: sin autoridad certificadora, sin internet y sin comprar nada. Los navegadores avisarán hasta que confíes en él, y la guía de instalación explica cómo.",
      "skip": "Omitir por ahora",
      "issue": "Emitir un certificado"
    },
    "done": "Compendio está listo."
  },
  "nav": {
    "home": "Inicio",
    "tree": "Páginas",
    "search": "Buscar",
    "tags": "Etiquetas",
    "recent": "Actualizado recientemente",
    "admin": "Administración",
    "newPage": "Página nueva",
    "newFolder": "Carpeta nueva",
    "deleteFolder": "Eliminar esta carpeta",
    "deleteFolderConfirm": "¿Eliminar «{{name}}» y todo su contenido? Las páginas se eliminan, pero su historial se conserva y se puede restaurar.",
    "deleteFolderCount_one": "Se elimina {{count}} página visible para usted.",
    "deleteFolderCount_other": "Se eliminan {{count}} páginas visibles para usted.",
    "folderDeleted": "Carpeta eliminada",
    "emptyTree": "Todavía no hay páginas. Crea la primera.",
    "collapse": "Contraer",
    "expand": "Expandir",
    "dashboard": "Panel",
    "notifications": "Notificaciones",
    "stale": "Revisión pendiente",
    "ask": "Preguntar al wiki"
  },
  "page": {
    "edit": "Editar",
    "view": "Ver",
    "history": "Historial",
    "delete": "Eliminar esta página",
    "deleteConfirm": "¿Eliminar «{{title}}»? Se borra el archivo, pero su historial se conserva y se puede restaurar.",
    "move": "Mover o renombrar",
    "moveName": "Nombre",
    "moveDestination": "Carpeta de destino",
    "moveRoot": "Nivel superior",
    "moveCurrent": "actual",
    "moveNoWrite": "solo lectura",
    "moveSubmit": "Mover",
    "moved": "Movido a {{path}}",
    "moveExists": "Ya existe una página o carpeta con ese nombre ahí.",
    "moveForbidden": "No tiene permiso para escribir ahí.",
    "moveNameSeparator": "Un nombre no puede contener «/» ni «\\». Elija la carpeta de abajo.",
    "moveNameIllegal": "Ese nombre no se puede usar para un archivo. Evite < > : \" | ? * y el punto o espacio final.",
    "deleteForbidden": "No tiene permiso para eliminar esto.",
    "updated": "Actualizada {{when}}",
    "updatedBy": "Actualizada {{when}} por {{who}}",
    "updatedExternally": "Actualizada {{when}} en la carpeta de contenido",
    "owner": "Responsable",
    "tags": "Etiquetas",
    "tableOfContents": "En esta página",
    "backlinks": "Enlazada desde",
    "noBacklinks": "Todavía ninguna otra página enlaza aquí.",
    "translations": "Otros idiomas",
    "translationStale": "La página original ha cambiado desde que se escribió esta traducción.",
    "onlyAvailableIn": "Esta página solo está disponible en {{language}}.",
    "attachments": "Adjuntos",
    "addAttachment": "Añadir un archivo",
    "attachmentAdded": "Archivo adjuntado.",
    "attachmentFailed": "No se ha podido adjuntar el archivo.",
    "deleteAttachment": "Eliminar el archivo",
    "deleteAttachmentNamed": "Eliminar «{{name}}»",
    "deleteAttachmentConfirm": "¿Eliminar «{{name}}»? Se quita de esta página y se borra el archivo. La edición de la página queda en su historial, pero el archivo no se puede restaurar desde ahí.",
    "attachmentDeleted": "Archivo eliminado.",
    "attachmentDeleteFailed": "No se ha podido eliminar el archivo.",
    "attachmentDeleteConflict": "La página se estaba guardando justo en ese momento, así que no se ha eliminado nada. Inténtalo otra vez.",
    "image": "Imagen",
    "imageZoom": "Ver esta imagen a tamaño completo",
    "imageZoomNamed": "Ver «{{name}}» a tamaño completo",
    "imageDimensions": "{{width}} × {{height}} px",
    "imageOriginal": "Abrir el original",
    "secure": "Carpeta cifrada",
    "secureHint": "Cualquiera con acceso de lectura puede leer esta página. Solo los administradores pueden modificarla.",
    "notCanonical": "Esta página se escribió fuera de Compendio. Al guardarla aquí por primera vez se ordenará su formato, una sola vez.",
    "empty": "Esta página está vacía. Pulsa Editar para empezar a escribir.",
    "created": "Página creada.",
    "saved": "Guardada.",
    "deleted": "Página eliminada.",
    "changeTitle": "Cambiar el título",
    "titleChanged": "Se ha cambiado el título.",
    "titleLabel": "Título",
    "newTitle": "¿De qué trata esta página?",
    "template": "Plantilla",
    "templateHint": "Una forma de partida. Borra lo que no necesites."
  },
  "editor": {
    "placeholder": "Escribe aquí. Pulsa / para ver el menú.",
    "markdownSource": "Código Markdown",
    "richText": "Con formato",
    "unsavedChanges": "Tienes cambios sin guardar.",
    "leaveConfirm": "¿Salir sin guardar? Perderás los cambios.",
    "draftRecovered": "Se ha recuperado un borrador sin guardar de {{when}}.",
    "discardDraft": "Descartar el borrador",
    "saveFailed": "No se pudo guardar. Tu texto sigue aquí: inténtalo de nuevo.",
    "saveForbidden": "No tienes permiso para guardar aquí. Tu texto sigue aquí: pide a un administrador acceso de escritura a esta carpeta.",
    "image": {
      "uploading": "Adjuntando la imagen…",
      "uploadButton": "Elegir una imagen",
      "orPasteLink": "o pega un enlace",
      "caption": "Escribe un pie de imagen",
      "confirm": "Confirmar",
      "needsSave": "Guarda la página primero; después podrás adjuntarle imágenes.",
      "failed": "No se ha podido adjuntar la imagen.",
      "onlyImages": "En el texto solo se pueden soltar imágenes. Para lo demás usa «Añadir un archivo» en la página."
    },
    "conflict": {
      "title": "Esta página cambió mientras la editabas",
      "explain": "Otra persona —o una edición hecha en la carpeta de contenido— guardó después de que abrieras esta página. No se ha perdido nada. Elige qué conservar.",
      "mine": "Mi versión",
      "theirs": "Su versión",
      "takeMine": "Quedarme con la mía",
      "takeTheirs": "Quedarme con la suya",
      "resolveOnDesktop": "Combinar necesita una pantalla más ancha. Abre esta página en un ordenador para resolverlo.",
      "resolved": "Combinada y guardada."
    },
    "menu": {
      "text": "Texto",
      "list": "Listas",
      "advanced": "Avanzado"
    },
    "toolbar": {
      "normalText": "Texto normal",
      "headingLevel": "Encabezado {{level}}",
      "bold": "Negrita",
      "italic": "Cursiva",
      "heading": "Encabezado",
      "bulletList": "Lista con viñetas",
      "orderedList": "Lista numerada",
      "taskList": "Lista de tareas",
      "quote": "Cita",
      "code": "Código",
      "codeBlock": "Bloque de código",
      "link": "Enlace",
      "image": "Imagen",
      "table": "Tabla",
      "divider": "Separador",
      "diagram": "Diagrama"
    },
    "paste": {
      "converted": "El contenido pegado se convirtió a texto con formato.",
      "plainText": "Pegar sin formato"
    }
  },
  "search": {
    "placeholder": "Buscar en títulos y contenido…",
    "results_one": "{{count}} resultado",
    "results_other": "{{count}} resultados",
    "noResults": "Nada coincide con «{{query}}».",
    "noResultsHint": "Prueba con menos palabras, o revisa la ortografía.",
    "quickSwitcher": "Ir a una página",
    "filters": "Puedes usar tag:, in:, owner:, lang: y updated:> en el cuadro de búsqueda.",
    "inLanguage": "en {{language}}",
    "indexRebuilding": "El índice de búsqueda se está reconstruyendo. Los resultados pueden estar incompletos un momento."
  },
  "help": {
    "title": "Guía",
    "forAdministrators": "Para administradores",
    "untranslated": "Este tema todavía no está traducido, así que se muestra en inglés.",
    "notFound": "Ese tema de la guía no existe.",
    "empty": "La guía no está disponible en esta instancia."
  },
  "history": {
    "title": "Historial de {{title}}",
    "versions": "Versiones",
    "compare": "Comparar",
    "restore": "Restaurar esta versión",
    "restoreConfirm": "¿Restaurar la versión del {{when}}? Esto añade una versión nueva en vez de quitar nada, así que se puede deshacer.",
    "restored": "Restaurada. Una versión nueva registra el cambio.",
    "sourceDiff": "Código",
    "renderedDiff": "Con formato",
    "added": "añadidas",
    "removed": "eliminadas",
    "source": {
      "Editor": "Editada aquí",
      "External": "Editada en la carpeta de contenido",
      "Move": "Movida",
      "Delete": "Eliminada",
      "Restore": "Restaurada",
      "Normalization": "Formato ordenado"
    },
    "noAuthor": "Sin autor: este cambio vino de la carpeta de contenido"
  },
  "admin": {
    "title": "Administración",
    "users": "Personas",
    "groups": "Grupos",
    "access": "Acceso",
    "secure": "Carpetas cifradas",
    "settings": "Configuración",
    "user": {
      "add": "Añadir una persona",
      "created": "Se ha añadido la persona.",
      "role": "Rol",
      "roles": {
        "Reader": "Lectura",
        "Editor": "Edición",
        "Admin": "Administración"
      },
      "roleHelp": "Un rol es un techo, no una concesión. Quien tenga Lectura nunca podrá escribir, diga lo que diga una carpeta.",
      "active": "Activa",
      "saved": "Se han guardado los datos de la persona.",
      "leaveBlankPassword": "Déjalo en blanco para mantener la contraseña actual.",
      "lastSignIn": "Último inicio de sesión",
      "never": "Nunca",
      "resetPassword": "Poner una contraseña nueva",
      "lastAdmin": "Siempre debe quedar un administrador activo."
    },
    "group": {
      "add": "Añadir un grupo",
      "name": "Nombre",
      "created": "Se ha añadido el grupo.",
      "rename": "Renombrar",
      "renamed": "Se ha renombrado el grupo.",
      "members": "Miembros",
      "manageMembers": "Gestionar miembros",
      "membersPlaceholder": "Elige a quién añadir",
      "membersSaved": "Se han guardado los miembros del grupo.",
      "noPeople": "No hay personas que coincidan",
      "memberCount_one": "{{count}} miembro",
      "memberCount_other": "{{count}} miembros"
    },
    "acl": {
      "title": "Acceso a {{path}}",
      "inherit": "Heredar de {{parent}}",
      "inheritRoot": "Heredar el valor por defecto de la instancia",
      "restricted": "Restringido: solo las personas y grupos de abajo",
      "currently": "Ahora mismo: {{summary}}",
      "addSubject": "Añadir una persona o un grupo",
      "everyone": "Cualquiera que inicie sesión",
      "levels": {
        "None": "Sin acceso",
        "Read": "Lectura",
        "Write": "Escritura",
        "Manage": "Gestión"
      },
      "preview": "Vista previa del acceso efectivo",
      "previewFor": "¿Qué puede hacer aquí esta persona?",
      "previewResult": "{{name}} puede: {{level}}",
      "reason": {
        "role.admin": "porque es administrador",
        "role.ceiling.Reader": "limitado por su rol de Lectura",
        "role.ceiling.Editor": "limitado por su rol de Edición",
        "secure.readOnly": "porque esta carpeta está cifrada y solo los administradores pueden modificarla",
        "instance.default": "por el valor por defecto de la instancia",
        "inherited": "heredado de una carpeta superior"
      },
      "noDeny": "No hay reglas de denegación. Para quitar acceso, corta la herencia y enumera quién entra.",
      "saved": "Reglas de acceso guardadas."
    },
    "secureScope": {
      "add": "Cifrar una carpeta",
      "path": "Carpeta",
      "threatModel": "Esto protege frente a un disco robado, un archivo de copia de seguridad, una carpeta mal sincronizada y un futuro espejo en git. No protege frente a un administrador de este servidor, y no oculta los nombres de carpetas ni de archivos.",
      "filesFirstSuspended": "Dentro de una carpeta cifrada se suspende el principio de archivos primero: runbook.md.enc no se abre en VS Code. Usa compendio secure export e import para una edición directa.",
      "indexContent": "Incluir estas páginas en la búsqueda",
      "indexContentWarning": "El contenido de las páginas se guardará sin cifrar en el índice de búsqueda dentro de compendio.db. Cualquiera con el archivo de base de datos podrá leerlo.",
      "allowAi": "Permitir que las funciones de IA lean estas páginas",
      "allowAiConfirm": "El contenido de esta carpeta cifrada se enviará a {{endpoint}} cada vez que alguien use una acción de IA sobre una página de dentro. ¿Continuar?",
      "allowAiOn": "Las páginas de aquí se envían a {{endpoint}} cuando se usa una acción de IA sobre ellas.",
      "allowAiOff": "El asistente de IA no puede leer estas páginas ni las citará.",
      "keyStatus": "Clave",
      "available": "Legible",
      "unavailable": "No disponible: ejecuta compendio doctor en el servidor",
      "created": "La carpeta ya está cifrada."
    },
    "status": {
      "title": "Estado",
      "version": "Versión",
      "installMode": "Instalado como",
      "contentRoot": "Carpeta de contenido",
      "pages": "Páginas",
      "folders": "Carpetas",
      "watcher": "Vigilancia de archivos",
      "index": "Índice de búsqueda",
      "queue": "En cola para indexar",
      "database": "Tamaño de la base de datos",
      "content": "Tamaño del contenido",
      "lastBackup": "Última copia de seguridad",
      "neverBackedUp": "Nunca: ejecuta compendio backup",
      "backup": "Crear una copia de seguridad",
      "backupHelp": "Escribe un archivo con el contenido y la base de datos en la carpeta de copias del servidor.",
      "backupPassphrase": "Frase de contraseña de la copia",
      "backupPassphraseHint": "Necesaria porque esta instancia tiene carpetas cifradas. Protege la clave de cifrado dentro del archivo: guárdala en un lugar distinto de este servidor, ya que la necesitarás para restaurar.",
      "backupDone": "Copia escrita: {{file}}",
      "reindex": "Reconstruir el índice de búsqueda",
      "reconcile": "Volver a leer la carpeta de contenido"
    },
    "audit": {
      "title": "Registro de auditoría",
      "action": "Acción",
      "actor": "Quién",
      "target": "Qué",
      "when": "Cuándo"
    },
    "ai": {
      "title": "Asistente de IA",
      "intro": "Opcional. Un único endpoint compatible con OpenAI cubre Ollama, Groq, OpenAI, Azure OpenAI, LM Studio y vLLM. Sin configurar, no aparece ningún control de IA en el producto.",
      "baseUrl": "URL base",
      "baseUrlHint": "La base de chat-completions, sin la ruta final. Ollama: http://localhost:11434/v1",
      "model": "Modelo",
      "modelHint": "Usa un modelo instruct estándar, p. ej. llama-3.3-70b-versatile. Los modelos de razonamiento (gpt-oss, DeepSeek-R1, serie o) son más lentos, más caros y no se recomiendan aquí.",
      "apiKey": "Clave de API",
      "apiKeyStored": "Hay una clave guardada. Déjalo en blanco para conservarla o escribe otra para sustituirla.",
      "apiKeyOptional": "Opcional. Ollama y LM Studio no la necesitan.",
      "privacyOn": "El contenido de las páginas se envía a {{endpoint}} cuando alguien usa una acción de IA. Un modelo local lo mantiene en esta máquina.",
      "privacyOff": "No hay proveedor configurado, así que no se envía nada a ninguna parte y no se muestra ningún control de IA.",
      "test": "Probar conexión",
      "testOk": "{{model}} respondió: {{reply}}",
      "testFailed": "Sin respuesta: {{detail}}",
      "disable": "Desactivar la IA",
      "limitsTitle": "Límites de uso",
      "limitsIntro": "Un endpoint de pago cobra por petición. Estos topes acotan lo que este wiki puede gastar en un día, contado sobre 24 horas móviles. 0 significa sin límite. Una petición que falle en el proveedor también cuenta, porque a esas alturas ya ha costado dinero.",
      "dailyPerUser": "Peticiones por persona y día",
      "dailyPerUserHint": "Conviene ser generoso: un editor que repasa una docena de páginas gasta unas cuarenta.",
      "dailyPerInstance": "Peticiones para todos por día",
      "dailyPerInstanceHint": "Un segundo techo para toda la instancia. Déjalo en 0 salvo que el endpoint sea de pago por uso.",
      "usedInLastDay": "{{used}} peticiones en las últimas 24 horas.",
      "topSpenders": "Quién más ha pedido",
      "scopeTitle": "Dónde se puede usar la IA",
      "allowedSpaces": "Espacios permitidos",
      "allowedSpacesHint": "Carpetas de primer nivel que el asistente puede leer. Déjalo vacío para todas.",
      "allowedSpacesPlaceholder": "IT, RRHH…",
      "features": "Funciones",
      "featuresHint": "Las funciones sin marcar desaparecen del producto por completo, en lugar de fallar al usarlas."
    },
    "git": {
      "title": "Espejo de git",
      "disabled": "Desactivado. Actívalo con GitMirror:Enabled y una URL remota.",
      "noGit": "Activado, pero git no está en PATH. El resto no se ve afectado.",
      "branch": "Enviando a la rama {{branch}}.",
      "lastSuccess": "Último envío {{when}}.",
      "neverPushed": "Activado, todavía no se ha enviado nada.",
      "lastError": "El último envío falló: {{detail}}",
      "pushNow": "Enviar ahora"
    },
    "integrations": "Integraciones",
    "deleted": {
      "title": "Páginas eliminadas",
      "intro": "Páginas cuyo archivo se eliminó pero cuyo historial se conserva. Restaurar devuelve la última versión, con todo su historial, al lugar donde estaba la página.",
      "empty": "No hay páginas eliminadas pendientes de restaurar.",
      "path": "Dónde estaba",
      "deletedAt": "Eliminada",
      "versions": "Versiones",
      "restore": "Restaurar",
      "restoreTo": "Restaurar en",
      "restoreToHint": "Déjalo como está para devolver la página a su sitio. Cámbialo si ahora hay otra cosa ahí.",
      "restored": "La página ha vuelto: {{path}}",
      "exists": "Ya hay algo en esa ruta. Elige otra."
    }
  },
  "about": {
    "title": "Acerca de Compendio",
    "version": "Versión {{version}}",
    "license": "Distribuido bajo la Licencia Pública General Affero de GNU, versión 3 o posterior.",
    "source": "Código fuente"
  },
  "template": {
    "blank": "Página en blanco",
    "procedure": "Procedimiento",
    "runbook": "Runbook",
    "policy": "Política",
    "meeting": "Notas de reunión"
  },
  "common": {
    "discard": "Descartar",
    "exportCsv": "Exportar CSV",
    "cancel": "Cancelar",
    "save": "Guardar",
    "close": "Cerrar"
  },
  "dashboard": {
    "title": "Panel",
    "myStalePages": "Tus páginas pendientes de revisión",
    "viewAll": "Ver todas",
    "nothingStale": "No tienes nada vencido. Eres responsable de {{count}} página(s).",
    "daysOverdue": "{{count}} d de retraso",
    "notifications": "Notificaciones recientes",
    "noNotifications": "Nada nuevo.",
    "acknowledgmentsOwed": "Tienes páginas cuya lectura debes confirmar",
    "overdue": "Vencida"
  },
  "notifications": {
    "title": "Notificaciones",
    "empty": "No hay nada aquí.",
    "markRead": "Marcar leída",
    "markAllRead": "Marcar todas como leídas",
    "unread": "Nueva"
  },
  "notification": {
    "PageStale": "Una página de la que eres responsable necesita revisión",
    "OwnedPageEditedExternally": "Una página tuya se editó en disco",
    "TranslationSourceChanged": "El origen de una traducción tuya ha cambiado",
    "AcknowledgmentRequested": "Confirma que has leído esta página",
    "AcknowledgmentOverdue": "Vencido: confirma que has leído esta página",
    "GitMirrorFailed": "El espejo de git no pudo enviar los cambios"
  },
  "stale": {
    "title": "Páginas pendientes de revisión",
    "count": "{{count}} página(s) han pasado su fecha de revisión",
    "empty": "No hay nada vencido.",
    "page": "Página",
    "owner": "Responsable",
    "due": "Vence",
    "overdue": "Retraso",
    "days": "{{count}} d",
    "unassigned": "Sin responsable",
    "unassignedOnly": "Sin responsable localizable",
    "freshnessColumn": "Comprobación de actualidad"
  },
  "lifecycle": {
    "staleTitle": "Esta página necesita revisión",
    "staleBody": "Responsable: {{owner}}. Comprueba que sigue siendo correcta y confírmalo.",
    "confirmReviewed": "Confirmar revisión",
    "nobody": "nadie",
    "panelTitle": "Revisión y responsable",
    "owner": "Responsable",
    "ownerHint": "Quién se encarga de que esta página siga siendo correcta. Recibe los avisos.",
    "noMatch": "Ninguna cuenta coincide",
    "unknownOwner": "{{owner}} (ninguna cuenta coincide)",
    "interval": "Revisar cada (días)",
    "intervalHint": "Déjalo vacío si no hay ciclo de revisión. Al indicarlo, el plazo empieza hoy.",
    "requiresAcknowledgment": "Requiere confirmación de lectura",
    "requiresAcknowledgmentHint": "A todo el que pueda leer esta página se le pedirá que confirme que lo ha hecho.",
    "currentlyDue": "Vence el {{date}}."
  },
  "acknowledgment": {
    "required": "Debes confirmar que has leído esta página",
    "body": "Lee la página y después confírmalo. Tu confirmación registra esta versión exacta.",
    "confirm": "He leído esta página",
    "report": "Confirmaciones",
    "progress": "{{done}} de {{total}} confirmadas",
    "version": "Medido sobre la versión {{sequence}}.",
    "person": "Persona",
    "status": "Estado",
    "outstanding": "Todavía no",
    "materialRevision": "Revisión importante",
    "materialRevisionHint": "Pedir a todos que la lean de nuevo"
  },
  "ai": {
    "menu": "IA",
    "sentTo": "Se envía a {{endpoint}}",
    "improvePage": "Mejorar la redacción",
    "improveSelection": "Mejorar la selección",
    "summarize": "Resumir",
    "freshness": "Buscar contenido desactualizado",
    "proposalTitle": "Cambio propuesto",
    "proposalNote": "De {{model}} en {{endpoint}}. No se guarda nada hasta que lo aceptes.",
    "proposalNoteReadOnly": "De {{model}} en {{endpoint}}. No se ha cambiado nada: esto es para que lo leas.",
    "freshnessResult": "Qué parece desactualizado",
    "accept": "Usar esto",
    "unreviewedTitle": "Traducción automática sin revisar",
    "unreviewedBody": "Esta traducción la generó un modelo y nadie la ha comprobado. Al guardar la página desde el editor este aviso desaparece.",
    "translate": "Traducir esta página",
    "translateNote": "La traducción la genera un modelo y nadie la ha comprobado. La página nueva queda marcada como sin revisar hasta que una persona la guarde.",
    "askTitle": "Preguntar al wiki",
    "askIntro": "Se responde solo con páginas que puedes leer, usando {{endpoint}}.",
    "askPlaceholder": "¿Qué quieres saber?",
    "ask": "Preguntar",
    "sources": "Fuentes",
    "noAnswer": "Ninguna de las páginas que puedes leer responde a eso.",
    "answeredBy": "Respondido por {{model}} en {{endpoint}}.",
    "unavailableTitle": "Preguntar al wiki no está disponible",
    "unavailableBody": "Esta instancia no tiene proveedor de IA configurado, o esta función está desactivada.",
    "summarizeSelection": "Resumir la selección",
    "proposalTitleSelection": "Cambio propuesto para tu selección",
    "acceptSelection": "Sustituir la selección",
    "working": "Esperando a {{endpoint}}. Un modelo local puede tardar un minuto o dos.",
    "budgetRemaining": "Te quedan {{remaining}} de {{limit}} peticiones de IA por hoy.",
    "quotaResetsAt": "Habrá más disponibles hacia las {{when}}.",
    "draft": "Redactar con IA",
    "draftTitle": "Redactar una página a partir de tus notas",
    "draftIntro": "Escribe lo que sepas como te salga: guiones, frases a medias, el orden en que lo recuerdes. {{endpoint}} lo convierte en una página estructurada que puedes editar.",
    "draftNotes": "Tus notas",
    "draftNotesHint": "Vale con algo tosco. A la mayoría le resulta más fácil que una página en blanco.",
    "draftPlaceholder": "- reiniciar el servicio desde la consola\n- mirar el log en D:\\logs\n- si falla dos veces, llamar a Ana",
    "draftTemplate": "Con la forma de",
    "draftTemplateHint": "Opcional. Usa las mismas plantillas de página que el resto del wiki.",
    "draftUnsavedNote": "El borrador aparece en el editor. No se guarda nada hasta que lo guardes tú.",
    "feature": {
      "improve": "Mejorar la redacción",
      "draft": "Redactar desde notas",
      "summarize": "Resumir",
      "translate": "Traducir",
      "ask": "Preguntar al wiki",
      "freshness": "Pistas de actualidad"
    }
  }
}
